(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const initCollapse = () => {
    document.querySelectorAll('.collapse_text').forEach(function (wrapper) {
      const content = wrapper.querySelector('rte-formatter');
      const moreBtn = wrapper.querySelector('.collaps_btn.is_more');
      const lessBtn = wrapper.querySelector('.collaps_btn.is_less');

      if (!content || !moreBtn || !lessBtn) return;

      const checkOverflow = () => {
        if (wrapper.classList.contains('is_open')) return;
        
        // Temporarily reset to see full height if it was hidden
        moreBtn.style.display = 'inline-block';
        
        const isOverflowing = content.scrollHeight > content.clientHeight;
        if (isOverflowing) {
          moreBtn.style.display = 'inline-block';
        } else {
          moreBtn.style.display = 'none';
        }
      };

      // Initial check
      setTimeout(checkOverflow, 100);

      moreBtn.addEventListener('click', function () {
        wrapper.classList.add('is_open');
        moreBtn.style.display = 'none';
      });

      lessBtn.addEventListener('click', function () {
        wrapper.classList.remove('is_open');
        checkOverflow();
      });

      // Handle responsiveness
      window.addEventListener('resize', checkOverflow);
    });
  };

  initCollapse();
});
  } catch(e) { console.error(e); }
})();

})();
